import {isDefined} from "../../libs/utils/epic.utils";
import {AffiliateReferredDto} from "./affiliate-referred.dto";

export class AffiliateDto {

  public readonly affiliateId!: string;
  public readonly commission!: number;
  public readonly referred: AffiliateReferredDto[] = [];

  constructor(init?: Partial<AffiliateDto> | undefined) {
    Object.assign(this, init);
    if (isDefined(init?.referred)) {
      this.referred = init?.referred.map((r) => new AffiliateReferredDto(r));
    }
  }
}
